<section class="page">
  <header class="page-header">
    <div>
      <h1>Kobble</h1>
      <p>Integration health and manual wallet credits</p>
    </div>
    <button class="btn btn-secondary" type="button" (click)="refreshHealth()" [disabled]="loadingHealth()">
      Refresh health
    </button>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }
  @if (success()) {
    <div class="alert alert-success">{{ success() }}</div>
  }

  <div class="grid">
    <div class="panel">
      <h2>Kobble health</h2>
      @if (loadingHealth()) {
        <p class="muted">Checking…</p>
      } @else {
        @if (health(); as h) {
          <dl class="meta">
            <div>
              <dt>Configured</dt>
              <dd>
                <span class="badge" [attr.data-status]="h.configured ? 'approved' : 'rejected'">
                  {{ h.configured ? 'yes' : 'no' }}
                </span>
              </dd>
            </div>
          </dl>
          <pre class="json">{{ h.health | json }}</pre>
        } @else {
          <p class="muted">No health data</p>
        }
      }
    </div>

    <div class="panel">
      <h2>Manual credit</h2>
      <p class="hint">
        Credits via Kobble and creates a local topup. Use the local numeric wallet ID (from Users →
        detail), or paste the Kobble wallet UUID.
      </p>
      <form [formGroup]="creditForm" (ngSubmit)="submitCredit()" class="credit-form">
        <label class="full">
          <span>Wallet ID (local # or Kobble UUID)</span>
          <input type="text" formControlName="wallet_ref" placeholder="e.g. 1 or uuid…" autocomplete="off" />
        </label>
        <label>
          <span>Amount (AUD)</span>
          <input type="number" formControlName="amount" min="0.01" step="0.01" />
        </label>
        <label>
          <span>Reference</span>
          <input type="text" formControlName="reference" />
        </label>
        <button class="btn btn-primary" type="submit" [disabled]="savingCredit()">
          {{ savingCredit() ? 'Submitting…' : 'Add credit' }}
        </button>
      </form>
    </div>
  </div>
</section>
